import { Flex, useColorModeValue } from "@chakra-ui/react";

interface RankBadgeProps {
  rank: number;
}

export const RankBadge = ({ rank }: RankBadgeProps) => {
  const background = useColorModeValue("gray.50", "gray.600");
  const color = useColorModeValue("gray.600", "gray.200");

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
      boxSize="19px"
      borderRadius="full"
      background={background}
      color={color}
      fontFamily="mono"
      fontSize="10px"
      fontWeight="bold"
    >
      {rank}
    </Flex>
  );
};
